<template>
  <div class="box sales-online">
    <details-box-heading :label="online.name" />

    <!-- SIGNED AT -->
    <div v-if="online.signed_at" class="box-content mb-2">
      <details-static-data-field field="Signed at" :value="online.signed_at" />
    </div>

    <!-- PANEL QUANTITY -->
    <div v-if="online.panel_quantity" class="box-content mb-2">
      <details-static-data-field field="Aantal panelen" :value="online.panel_quantity" />
    </div>

    <!-- VIEW CONTRACT -->
    <div v-if="online.contract_url" class="box-content mb-2">
      <div class="buttons is-left">
        <details-PDF-viewer
          :title="`Akkoordverklaring online (${address})`"
          label="Show contract"
          :source="online.contract_url"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import DetailsPaneBase from './DetailsPaneBase.vue'

@Component({
  name: 'DetailsSalesOnlineBox',
})
export default class DetailsSalesOnlineBox extends DetailsPaneBase {
  get online() {
    return this.components.online || {}
  }
}
</script>
